import { defineStore, acceptHMRUpdate } from 'pinia'

export const useRootStore = defineStore('root', {
    state: () => ({
        version: 'v5.0.0',
        isChatLoading: false as boolean,
        drift: null as any,
    }),
    actions: {
        activateDrift() {
            this.isChatLoading = true;

            // Initialize Drift snippet
            (function () {
                const t = (window.driftt = window.drift = window.driftt || []) as any;
                if (!t.init) {
                    if (t.invoked) {
                        if (window.console && console.error) {
                            console.error("Drift snippet included twice.");
                        }
                        return;
                    }
                    t.invoked = true;
                    t.methods = [
                        "identify",
                        "config",
                        "track",
                        "reset",
                        "debug",
                        "show",
                        "ping",
                        "page",
                        "hide",
                        "off",
                        "on",
                    ];

                    t.factory = function (e: string) {
                        return function () {
                            const n = Array.prototype.slice.call(arguments);
                            n.unshift(e);
                            t.push(n);
                            return t;
                        };
                    };

                    t.methods.forEach((e: string) => {
                        t[e] = t.factory(e);
                    });

                    t.load = function (id: string) {
                        const e = 300000;
                        const n = Math.ceil(new Date().getTime() / e) * e;
                        const o = document.createElement("script");
                        o.type = "text/javascript";
                        o.async = true;
                        o.crossOrigin = "anonymous";
                        o.src = `https://js.driftt.com/include/${n}/${id}.js`;
                        const i = document.getElementsByTagName("script")[0];
                        i.parentNode.insertBefore(o, i);
                    };
                }
            })();

            (window as any).drift.SNIPPET_VERSION = "0.3.1";
            (window as any).drift.load("ygzakh2wu9an");

            // Attach ready listener
            (window as any).drift.on("ready", (api: any, payload: any) => {
                this.drift = (window as any).drift;
                this.drift.api.openChat();
                this.isChatLoading = false;
            });
        },

        showDriftChat() {
            if (this.drift) {
                this.drift.api.openChat();
            }
        },

        hideDriftChat() {
            if (this.drift) {
                this.drift.api.widget.hide();
            }
        },
    },
})

if (import.meta.hot) {
    import.meta.hot.accept(acceptHMRUpdate(useRootStore, import.meta.hot))
}
